import styled from "styled-components";

export const MediaImage = styled.img`
  min-width: 50px;
  min-height: 50px;
  max-width: 100%;
  max-height: 70vh;
`;
